export default {
  text: 'Du verdienst <highlight>{{value}} Punkte</highlight> mit dieser Bestellung',
};
